import { Box } from '@/components';
import { BORDER_STYLE_SECONDARY } from '@/features/mold/components';
import type { FC, ReactNode } from 'react';

type Props = {
  cellColRatios?: (number | string)[];
  cellRowRatios?: (number | string)[];
  containedCell: ReactNode;
  includedCell: ReactNode;
};

export const SubsetCells: FC<Props> = ({
  cellColRatios,
  cellRowRatios,
  containedCell,
  includedCell,
}) => {
  const wrapperLayoutStyles = {
    display: 'grid',
    gridTemplateColumns: (cellColRatios || [1, 1])
      .map((item) => (typeof item === 'number' ? `${item}fr` : item))
      .join(' '),
    gridAutoRows: (cellRowRatios || [1, 1])
      .map((item) => (typeof item === 'number' ? `${item}fr` : item))
      .join(' '),
    height: '100%',
  };

  const parentLayoutStyles = {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    gridRowStart: 1,
    gridRowEnd: 2,
    height: '100%',
  };

  const childLayoutStyles = {
    gridColumnStart: 2,
    gridRowStart: 2,
    gridRowEnd: 3,
    height: '100%',
  };

  return (
    <Box {...wrapperLayoutStyles} boxSizing="border-box">
      <Box {...parentLayoutStyles}>{containedCell}</Box>

      <Box
        {...childLayoutStyles}
        borderTop={BORDER_STYLE_SECONDARY}
        borderLeft={BORDER_STYLE_SECONDARY}
        boxSizing="border-box"
      >
        {includedCell}
      </Box>
    </Box>
  );
};
